import React from 'react';
import { cn } from './cn';

/**
 * Kbd — keyboard shortcut chip. Use inside menus, tooltips, help panels.
 *   <Kbd>⌘K</Kbd>  <Kbd>Esc</Kbd>  <Kbd>Shift</Kbd>+<Kbd>Enter</Kbd>
 */
export function Kbd({ className, children }) {
  return (
    <kbd
      className={cn(
        'inline-flex items-center justify-center',
        'min-w-[20px] h-5 px-1.5',
        'rounded border border-line bg-surface shadow-[0_1px_0_rgb(var(--border)/1)]',
        'font-mono text-[11px] leading-none text-fg-muted',
        className,
      )}
    >
      {children}
    </kbd>
  );
}

export default Kbd;
